<app-admin-side-bar></app-admin-side-bar>
<!-- Navbar -->
<nav class="main-header navbar navbar-expand navbar-dark">
  <!-- Left navbar links -->
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
    </li>
    <li class="nav-item d-none d-sm-inline-block">
      <a class="nav-link">Home</a>
    </li>
    <li class="nav-item d-none d-sm-inline-block">
      <a class="nav-link">Discount Templates</a>
    </li>
  </ul>

  <!-- Right navbar links -->
  <ul class="navbar-nav ml-auto">
    <li class="nav-item dropdown">
      <!-- <a><app-admin-test-mode></app-admin-test-mode> </a> -->
    </li>
  </ul>
</nav>
<!-- /.navbar -->

<div class="content-wrapper">
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Customized Discount Templates</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a>Home</a></li>
            <li class="breadcrumb-item active">Customized Discount Templates</li>
          </ol>
        </div>
      </div>
    </div><!-- /.container-fluid -->
  </section>

  <div class="container-fluid" style="padding: 15px;">

    <div class="row ">
      <section class="col-md-3">
        <!-- <button class="popup-button" mat-button (click)="openCreateModal()">Add-Country</button> -->
        <!-- <button type="button" (click)="openCreateModal()" class="btn btn-primary">
          Add Discount Template
        </button> -->

      </section>
      <section class="col-md-6">

      </section>
      <section class="col-md-3" style="float: right;">
        <!-- <input type="text" #keyword placeholder="Search"> &nbsp; -->
        <!-- <button class="btnDef" (click)="Filter(keyword.value)">Search</button> -->
      </section>

    </div>
    <div class="row">
      <section class="col-md-12 mt-2">

        <div class="card">

          <!-- /.card-header -->
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="tabset" style="max-width: 100%;">
                  <!-- Tab 1 -->
                  <input type="radio" name="tabset" id="tab1" aria-controls="international" checked>
                  <label for="tab1">International</label>
                  <!-- Tab 2 -->
                  <input type="radio" name="tabset" id="tab2" aria-controls="domestic">
                  <label for="tab2">Domestic</label>
                  <!-- Tab 3 -->
                  <input type="radio" name="tabset" id="tab3" aria-controls="product">
                  <label for="tab3">Product</label>

                  <div class="tab-panels">
                    <section id="international" class="tab-panel">
                      <h2>International</h2><br>
                      <div class="row">
                        <div class="col-4">
                          <button type="button" (click)="openCreateModal()" class="btn btn-primary">
                            Add International Discount Template
                          </button>
                        </div>
                        <div class="col-5"></div>
                        <div class="col-3">
                          <input type="text" #keyword placeholder="Search"> &nbsp;
                          <button class="btnDef" (click)="FilterInternational(keyword.value)">Search</button>
                        </div>
                      </div>

                      <br><br>
                      <div *ngIf="loader==true">
                        <app-loader></app-loader>
                      </div>
                     <div style="height: 520px; overflow: scroll;">
                      <table *ngIf="loader==false" id="example2" class="table table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>Country</th>
                            <th>Operators</th>
                            <th>Amount</th>
                            <th>SKU Code</th>
                            <th>To Retailer</th>
                            <th>From Ding</th>
                            <th>Prid Profit</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody *ngFor="let discount of customDiscount; let i = index;">
                          <tr>
                            <td>{{discount.productTitle}}</td>
                            <td>{{discount.providerCode}}</td>
                            <td>{{discount.amount}}</td>
                            <td>{{discount.skuCode}}</td>
                            <td>{{discount.discountPercentage}}</td>
                            <td>{{discount.prideComissionPercentage}}</td>
                            <td>{{discount.prideProfitPercentage}}</td>

                            <td>

                              <i class="fa fa-trash" (click)="Delete(discount.id)"></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                     </div>

                      <div class="d-flex justify-content-center my-3" *ngIf="internationalTotalCount > 0">
                        <app-pager [totalCount]="internationalTotalCount" [pageSize]="100"
                          (pageChanged)="onPageChanged($event)"></app-pager>
                      </div>

                    </section>
                    <section id="domestic" class="tab-panel">
                      <h2>Domestic</h2>
                      <br>

                      <div class="row">
                        <div class="col-4">
                          <button type="button" (click)="openDomesticCreateModal()" class="btn btn-primary">
                            Add Domestic Discount Template
                          </button>
                        </div>
                        <div class="col-5"></div>
                        <div class="col-3">
                          <input type="text" #keywordDomestic placeholder="Search"> &nbsp;
                          <button class="btnDef" (click)="FilterDomestic(keywordDomestic.value)">Search</button>
                        </div>
                        <br><br>
                        <div *ngIf="domesticloader==true">
                          <app-loader></app-loader>
                        </div>
                      </div>
                      <div style="height: 520px; overflow: scroll;">
                      <table *ngIf="domesticloader==false" id="example2" class="table table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>Country</th>
                            <th>Operators</th>
                            <th>Amount</th>
                            <th>SKU Code</th>
                            <th>To Retailer</th>
                            <th>From Ding</th>
                            <th>Prid Profit</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        
                          <tbody *ngFor="let discount of domesticDiscounts; let i = index;">
                            <tr>
                              <td>{{discount.productTitle}}</td>
                              <td>{{discount.providerCode}}</td>
                              <td>{{discount.amount}}</td>
                              <td>{{discount.skuCode}}</td>
                              <td>{{discount.discountPercentage}}</td>
                              <td>{{discount.prideComissionPercentage}}</td>
                              <td>{{discount.prideProfitPercentage}}</td>
  
                              <td>
  
                                <i class="fa fa-trash" (click)="Delete(discount.id)"></i>
                              </td>
                            </tr>
                          </tbody>
                       
                      </table>
                    </div>
                      <div class="d-flex justify-content-center my-3" *ngIf="domesticTotalCount > 0">
                        <app-pager [totalCount]="domesticTotalCount" [pageSize]="100"
                          (pageChanged)="onPageChangedDomestic($event)"></app-pager>
                      </div>

                    </section>
                    <section id="product" class="tab-panel">
                      <h2>Product</h2>
                      <br>
                      <div class="row">
                        <div class="col-4">
                          <button type="button" (click)="openProductCreateModal()" class="btn btn-primary">
                            Add Products Discount
                          </button>
                        </div>
                        <div class="col-5"></div>
                        <div class="col-3">
                          <input type="text" #keywordPrid placeholder="Search"> &nbsp;
                          <button class="btnDef" (click)="FilterPrid(keywordPrid.value)">Search</button>
                        </div>
                      </div>
                      <br><br>
                      <div *ngIf="domesticloader==true">
                        <app-loader></app-loader>
                      </div>
                      <br><br>
                      <div *ngIf="pridloader==true">
                        <app-loader></app-loader>
                      </div>
                      <table *ngIf="pridloader==false" id="example2" class="table table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Product Title</th>
                            <th>SKU</th>
                            <th>Discount %</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody *ngFor="let discount of pridDiscounts; let i = index;">
                          <tr>
                            <td>{{discount.id}}</td>
                            <td>{{discount.productTitle}}</td>
                            <td>{{discount.skuCode}}</td>
                            <td>{{discount.discountPercentage}}</td>

                            <td>
                              <!-- <i class="fa fa-check" (click)="Delete(discount.id)"></i> -->
                              &nbsp;&nbsp;&nbsp;
                              <i class="fa fa-trash" (click)="Delete(discount.id)"></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="d-flex justify-content-center my-3" *ngIf="pridTotalCount > 0">
                        <app-pager [totalCount]="pridTotalCount" [pageSize]="100"
                          (pageChanged)="onPageChangedPrid($event)"></app-pager>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-5"></div>
              <div class="col-2">
                <div *ngIf="loader==true">
                  <app-loader style="text-align: center;"></app-loader>
                </div>
              </div>
              <div class="col-5"></div>
            </div> -->

          </div>
          <!-- 
          <div class="d-flex justify-content-center my-3" *ngIf="totalItems > 0">
            <app-pager [totalCount]="totalItems" [pageSize]="10" (pageChanged)="onPageChanged($event)"></app-pager>
          </div> -->

          <!-- /.card-body -->
        </div>

      </section>
    </div>
  </div>


</div>
